import React from "react";

interface AlgoForgeLogoProps {
  size?: number;
  className?: string;
}

export const AlgoForgeLogo = React.memo(
  ({ size = 128, className }: AlgoForgeLogoProps) => (
    <svg
      version="1.1"
      id="logoAlgoForge"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 791.3 809.2"
      fill="inherit"
      width={size}
      height={size}
      className={className}
    >
      <g id="Marteau">
        <path
          className="st0"
          d="M684.8,332l-205.3-45.7c-2-0.4-3.2-2.4-2.8-4.3c0,0,0,0,0-0.1l7.5-30.4c0.5-1.9,2.4-3.1,4.3-2.7l204.6,45.8
	c10.3,2.3,16.8,12.5,14.5,22.8c-0.1,0.3-0.2,0.7-0.3,1l0,0C704.7,328.3,694.7,334.3,684.8,332z"
        />
        <path
          className="st0"
          d="M456.8,290.4l11.9,2.9c0.3,0.1,0.5-0.1,0.6-0.3c0,0,0,0,0,0l10.8-54.6c0.1-0.3-0.1-0.5-0.4-0.6c0,0,0,0,0,0
	l-11-1.4c-0.2,0-0.5,0.1-0.5,0.4l-11.7,53.2C456.4,290.1,456.5,290.4,456.8,290.4C456.8,290.4,456.8,290.4,456.8,290.4z"
        />
        <polyline
          className="st0"
          points="452,286.4 429,323 386.3,313 379.6,246 415.4,189.1 458.1,199.1 462,237.8 	"
        />
        <line className="st1" x1="516.8" y1="223.9" x2="587.7" y2="202.8" />
        <path
          d="M514.7,216.7l71.7-18.4c2.6-0.7,5.2,0.8,5.9,3.4c0.7,2.5-0.7,5-3.1,5.8L519,231.1c-3.9,1.4-8.2-0.7-9.6-4.6
	s0.7-8.2,4.6-9.6C514.2,216.8,514.5,216.7,514.7,216.7L514.7,216.7z"
        />
        <line className="st1" x1="493.9" y1="178.3" x2="603.4" y2="66.5" />
        <path
          d="M488.5,173.1L600.4,63.6c1.6-1.6,4.2-1.7,5.9-0.1c1.6,1.6,1.7,4.2,0.1,5.9l0,0L499.2,183.6
	C492,190.7,481.6,180.6,488.5,173.1L488.5,173.1z"
        />
        <line className="st1" x1="448.5" y1="155.1" x2="468.2" y2="85.9" />
        <path
          d="M441.3,153l22.9-68.3c0.8-2.2,3.2-3.3,5.4-2.6c2,0.7,3.2,2.8,2.7,4.9l-16.6,70.1c-0.9,4-4.9,6.6-9,5.7
	c-4-0.9-6.6-4.9-5.7-9C441.1,153.6,441.2,153.3,441.3,153L441.3,153z"
        />
        <line className="st1" x1="398.7" y1="151.5" x2="357.5" y2="4.3" />
        <path
          d="M391.5,153.6L353.3,5.5c-0.6-2.3,0.9-4.7,3.2-5.2c2.2-0.5,4.5,0.7,5.2,2.9L406,149.5C408.5,159.3,394.5,163.3,391.5,153.6
	L391.5,153.6z"
        />
        <line className="st1" x1="360.5" y1="185.1" x2="306.6" y2="131.6" />
        <path
          d="M355.2,190.4L304,134.2c-1.4-1.6-1.2-3.9,0.3-5.3c1.4-1.3,3.5-1.3,5,0l56.5,50.9c3.1,2.8,3.4,7.5,0.6,10.6
	c-2.8,3.1-7.5,3.4-10.6,0.6C355.6,190.8,355.4,190.6,355.2,190.4z"
        />
        <line className="st1" x1="333.6" y1="227.9" x2="180.2" y2="185.9" />
        <path
          d="M331.6,235.2l-152.2-46.3c-1.6-0.4-2.6-2.1-2.1-3.7c0.4-1.6,2.1-2.6,3.7-2.1l154.6,37.7
	C345.3,223.5,341.6,237.7,331.6,235.2L331.6,235.2z"
        />
        <line className="st1" x1="333.6" y1="274.6" x2="268.2" y2="292.9" />
        <path
          d="M335.6,281.8l-26.3,5.6l-40.2,8.5c-1.7,0.4-3.4-0.7-3.8-2.5c-0.3-1.6,0.6-3.1,2.1-3.7l64.2-22.5c3.9-1.3,8.2,0.8,9.5,4.7
	s-0.8,8.2-4.7,9.5C336.1,281.7,335.9,281.7,335.6,281.8L335.6,281.8z"
        />
      </g>
      <g id="AlgoForge">
        <path
          d="M68.1,444.7c-1.2-6-2-10-2.5-12.1c-0.2-1.1-0.4-2.3-0.7-3.6s-0.6-2.8-1-4.4H37.4L33,444.7H0l6.5-29.2
	c8.6-37.7,14.1-62.7,16.5-74.9h55.4c4,19.3,11.8,54,23.3,104.1H68.1z M60.4,407.6c-5-24.3-8-42.9-9-55.9h-1.7
	c-1.5,14.7-4.4,33.3-8.9,55.9H60.4z"
        />
        <path
          d="M108,392.7c0-15.3-0.2-32.7-0.6-52.1h32.9c-0.3,15.4-0.5,31.4-0.5,48c0,10.1,0.1,20.1,0.3,30.1c10.6,0,23.2-0.1,37.7-0.3
	l-2.3,26.2h-68.1C107.8,425.3,108,408,108,392.7z"
        />
        <path
          d="M185.6,432.8c-6.6-9.2-9.9-22.6-9.9-40.2c0-18.6,3.7-32.2,11-40.9c7.3-8.6,19.2-12.9,35.7-12.9c11.7,0,20.8,1.5,27.4,4.6
	c6.4,2.9,11.5,8,14.3,14.5c2.9,6.6,4.6,15.5,5.2,26.8l-32.2,3.4c-0.4-7.9-1.7-14.1-4.1-18.5c-2.1-4.2-6.5-6.8-11.2-6.6
	c-3.7-0.1-7.3,0.5-10.9,1.6c-1.1,4.1-1.9,8.2-2.5,12.3c-0.6,4.8-0.8,9.6-0.8,14.4c0,9,1.4,16.5,4.3,22.5c2.9,6,7.1,9,12.6,9
	c3.4,0,6.8-0.5,10.1-1.4c2-0.9,3.8-2.1,5.5-3.5c0.7-0.7,1.4-1.3,2.2-1.8c0-3.3-0.7-5.8-2.2-7.7c-1.5-1.9-3.8-2.8-6.8-2.8h-8v-6.8
	h47.6v12.4c0,12.7,0,23.9,0.1,33.4h-31.4l0.6-23.2h-2c-1,8.5-3.6,14.8-7.9,18.9c-4.3,4.1-10.1,6.2-17.3,6.2
	C201.9,446.6,192.1,442,185.6,432.8z"
        />
        <path
          d="M298,441c-7-3.8-12.5-10.1-15.4-17.5c-3.3-7.9-4.9-18.2-4.9-30.8c0-18.7,3.7-32.4,11.2-40.9c7.4-8.5,19.3-12.8,35.6-12.8
	c11.2,0,20.4,1.9,27.4,5.7c7.1,3.9,12.6,10.1,15.6,17.7c3.3,8,5,18.2,5,30.9c0,18.5-3.8,32-11.5,40.6c-7.7,8.6-19.5,12.9-35.5,12.9
	C314.2,446.6,305,444.7,298,441z M336.7,421.5c2.3-9,3.4-18.3,3.4-27.5c0-9-1.3-16.4-4-22.2c-2.7-5.8-6.8-8.7-12.4-8.7
	c-3.8,0-7.5,0.5-11.1,1.6c-0.9,4-1.7,8.1-2.2,12.2c-0.5,4.9-0.8,9.8-0.7,14.7c0,9,1.4,16.5,4.2,22.4s7,8.9,12.5,8.9
	C330,423,333.4,422.5,336.7,421.5z"
        />
        <path
          d="M778.3,423.3h13v-11.8c0-2,0-14.4,0-15.3c0-1.2-3.4-0.6-4.6-0.1c0.1,3.4-0.7,4.1-2.2,6c-1.3,1.7-2.8,1.2-4.9,1.2h-27.9V388
	l36.4,0.9v-7.1h-62.4c0,7.2-0.1,14.5-0.2,21.5c-0.1,7.7-0.3,14.4-0.5,20.1h48.5c1.5,0,4.8,0.7,5.8-0.6c1.5-1.8,3.5-4.5,4-6.9
	c0.3,1.1,0.5,2.3,0.6,3.5c0.1,1.4,0.1,2.7,0,4.1"
        />
        <path
          d="M786.6,367.4c0.1-3.4-0.7-4.1-2.2-6c-1.3-1.7-2.8-1.2-4.9-1.2h-27.9v15.3l36.4-0.9v7.1h-62.4c0-7.2-0.1-14.4-0.2-21.4
	c-0.1-7.7-0.3-14.4-0.5-20.1h66.3V352c0,2,0,14.4,0,15.3C791.2,368.5,787.8,368,786.6,367.4z"
        />
        <g className="st2">
          <path
            d="M404.1,382.6c0-5.5-0.1-14.4-0.4-26.8c-0.1-7.5-0.2-12.2-0.2-14.3h63.2v19.2h-37.4l0.1,17.6l34.4-0.9v16.8l-34.4-0.9
		c0,8.5,0.1,18.5,0.2,30.1h-26.1C403.9,406.2,404.1,392.5,404.1,382.6z"
          />
        </g>
        <g className="st2">
          <path
            d="M488.1,420.6c-5.6-3-9.7-7.6-12.4-13.8c-2.6-6.2-4-14.3-4-24.3c0-14.8,3-25.5,9-32.2c6-6.7,15.6-10.1,28.7-10.1
		c9.1,0,16.4,1.5,22.1,4.5c5.7,3,9.8,7.6,12.5,13.9c2.7,6.3,4.1,14.4,4.1,24.3c0,14.5-3.1,25.2-9.3,32
		c-6.2,6.8-15.7,10.2-28.7,10.2C501.1,425.1,493.7,423.6,488.1,420.6z M519.3,405.3c1.8-6.9,2.7-14.1,2.7-21.7
		c0-7.1-1.1-12.9-3.2-17.5c-2.1-4.6-5.5-6.9-10-6.9c-3.2,0-6.1,0.4-9,1.3c-0.8,3.2-1.4,6.4-1.7,9.6c-0.4,3.2-0.6,7-0.6,11.6
		c0,7.1,1.1,13,3.4,17.7c2.2,4.7,5.6,7,10.1,7C514.5,406.4,517.2,406,519.3,405.3z"
          />
          <path
            d="M557,382.6c0-13-0.2-26.7-0.5-41.1h39.9c7.9,0,14.4,0.6,19.3,1.9c5,1.3,8.7,3.5,11.3,6.7c2.6,3.2,3.9,7.7,3.9,13.5
		c0,8.2-2.1,14-6.3,17.4c-4.2,3.4-11,5.1-20.3,5.1v1.7c9.1,0.1,15.6,1.5,19.5,4.1c3.9,2.6,6.1,6.8,6.6,12.4c0.1,2,0.6,5.2,1.5,9.6
		c0.9,4.4,1.7,7.6,2.4,9.6h-28c-1.3-8-2.1-14.3-2.3-18.7c-0.4-2.5-0.8-4.4-1.4-5.8c-0.6-1.3-1.6-2.3-2.9-2.8
		c-1.3-0.6-3.3-0.9-5.8-0.9h-11.4v8.9v19.2h-26C556.8,409.1,557,395.5,557,382.6z M601.1,377.6c2-1.5,3.1-4.2,3.1-7.9
		c0-3.9-1-6.6-3.1-8.1c-2-1.5-5.2-2.3-9.4-2.3h-9.6v20.5h9.8C596,379.9,599.1,379.2,601.1,377.6z"
          />
          <path
            d="M646.3,414.2c-5.3-7.3-8-17.8-8-31.7c0-14.7,3-25.4,8.9-32.2c5.9-6.8,15.5-10.2,28.7-10.2c9.4,0,16.8,1.2,22.1,3.6
		c5.3,2.4,9.1,6.2,11.5,11.4c2.4,5.2,3.7,12.2,4.2,21.1l-25.9,2.7c-0.3-6.2-1.4-11.1-3.3-14.6c-1.9-3.5-4.9-5.2-9-5.2
		c-3.2,0-6.1,0.4-8.7,1.3c-0.9,3.4-1.6,6.6-2,9.7c-0.4,3.1-0.6,6.9-0.6,11.3c0,7.1,1.2,13,3.5,17.7s5.7,7.1,10.1,7.1
		c2.7,0,5.4-0.4,8.1-1.1c1.1-0.4,2.6-1.4,4.4-2.8c0.5-0.5,1.1-1,1.8-1.4c0-2.6-0.6-4.6-1.8-6.1c-1.2-1.5-3-2.2-5.5-2.2h-6.4v-5.4
		h38.3v9.8c0,10,0,18.8,0.1,26.3h-25.3l0.5-18.3h-1.6c-0.8,6.7-2.9,11.6-6.4,14.9c-3.5,3.3-8.1,4.9-14,4.9
		C659.5,425.1,651.6,421.4,646.3,414.2z"
          />
        </g>
      </g>
      <g id="Anvil">
        <path
          d="M513.1,538.2h106.3c38.3-25,93.7-50.8,171.7-76.2v-33.4H371.6v20.5L0,446.2c0,0,7.3,139.8,308.1,146.4
	c0,0,106.9,66.6-82.7,162.5l-0.7,54.2H322c0,0,101-67.3,207.9,0h97.3v-55.6c0,0-147.7-81.1-50.8-180.8h-30c-6.4,0-6.4-10,0-10h40.5
	c5.5-4.8,11.5-9.7,18.2-14.6h-91.9C506.7,548.2,506.7,538.2,513.1,538.2z"
        />
      </g>
    </svg>
  )
);
